module.exports = "../../app/cells/components/modals/setup_wizard/practice_mode.erb";